// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:48:14

export default {
  "id": "cyberpunk-agent",
  "slug": "cyberpunk-agent",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7203420755834966b2e7b56d8fc698dc-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7203420755834966b2e7b56d8fc698dc/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Cyberpunk Agent",
      "description": "Cyberpunk Agent is the most challenging shooting game available full of thrilling missions.\nGet ready to enjoy this action packed eye popping game.\nYour arena is attacked by scary zombies.\nThey want to eat civilians. They are planning the dangerous missions to harm the innocents.\nIts time to save your people and kill all zombies.\nUse your best assassin skills and fight with these scary zombies.",
      "instructions": "Choose the role to move and shoot the zombies. \nEvery round has its missions which you have to complete. \nYou can get money and diamonds to update your role and arm. \nCome on and pass more levels!\n\nDesktop:\nUse WASD to move your player\n\nMobile:\nSwipe on screen to move\n\nThere are two buttons one to shoot right and the other to shoot left",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "3d",
        "agent",
        "guns",
        "levels",
        "shoot-em-up"
      ]
    },
    "zh-CN": {
      "title": "赛博朋克特工",
      "description": "赛博朋克特工是难度最高的射击游戏，充满了惊心动魄的任务。\n准备好享受这款充满动作、令人眼花缭乱的游戏。\n你的竞技场遭到恐怖僵尸的袭击。\n他们想要吞噬平民。他们正策划危险的行动来伤害无辜者。\n是时候拯救你的同胞并消灭所有僵尸了。\n运用你最佳的刺客技能，与这些恐怖僵尸战斗。",
      "instructions": "选择移动和射击僵尸的角色。\n每一轮都有其任务，你必须完成。\n你可以获得金钱和钻石来升级你的角色和装备。\n快来通关更多关卡！\n\n桌面版：\n使用WASD键移动你的玩家\n\n移动版：\n在屏幕上滑动来移动\n\n有两个按钮，一个用于射击右侧，另一个用于射击左侧",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "三维",
        "代理",
        "枪械",
        "关卡",
        "射击游戏"
      ]
    },
    "zh-TW": {
      "title": "赛博朋克特工",
      "description": "《Cyberpunk Agent》是最具挑戰性的射擊遊戲，滿滿的刺激任務等待著你。\n準備好享受這款動作緊湊、令人眼睛為之一亮的遊戲。\n你的比賽場地遭到恐嚇的僵屍攻擊。\n他們想要吃掉平民。他們計劃進行危險任務來傷害無辜的人。\n是時候拯救你的子民，殺死所有的僵屍了。\n使用你最好的刺客技能，與這些恐嚇的僵屍戰鬥。",
      "instructions": "選擇角色移動並射擊僵尸。\n每一回合都有其任務，您必須完成。\n您可以獲得金錢和鑽石來更新您的角色和裝備。\n快來吧！通過更多關卡！\n\n桌面版：\n使用 WASD 鍵移動您的玩家\n\n手機版：\n在螢幕上滑動以移動\n\n有兩個按鈕，一個用於向右射擊，另一個用於向左射擊",
      "genres": [
        "隨意型",
        "射擊類"
      ],
      "tags": [
        "3D",
        "代理",
        "槍械",
        "關卡",
        "射擊遊戲"
      ]
    },
    "zh-HK": {
      "title": "赛伯朋克特工",
      "description": "赛博特工是市面上最具挑戰性的射擊遊戲，充滿驚險任務。\n準備好享受這款充滿動作與驚艷視覺的遊戲。\n你的戰場受到恐怖僵屍的攻擊。\n他們想要吞噬平民。他們計劃危險任務來傷害無辜者。\n是時候拯救你的同胞並消滅所有僵屍了。\n使用你最擅長的刺客技能，與這些恐怖僵屍戰鬥。",
      "instructions": "選擇角色移動及射擊僵屍。\n每回合都有任務等你完成。\n你可以獲得金錢和鑽石來升級角色及裝備。\n快來吧！通過更多關卡！\n\n桌面版：\n使用WASD鍵移動玩家\n\n移動版：\n在螢幕上滑動以移動\n\n有兩個按鈕，一個用於射擊右邊，另一個用於射擊左邊",
      "genres": [
        "隨意射擊遊戲"
      ],
      "tags": [
        "3D",
        "代理",
        "槍械",
        "關卡",
        "射擊遊戲"
      ]
    },
    "ja": {
      "title": "サイバーパンクエージェント",
      "description": "サイバーパンクエージェントは、刺激的なミッションで満ち溢れた最も挑戦的な射撃ゲームです。\nこのアクション満載の目を見張るようなゲームを楽しむ準備をしましょう。\nあなたのアリーナが恐ろしいゾンビに攻撃されています。\n彼らは市民を食べようとしています。無垢な人々を傷つける危険な作戦を計画しています。\nあなたの国民を救い、すべてのゾンビを殺す時が来ました。\n最も優れたアサシンスキルを使って、これらの恐ろしいゾンビと戦ってください。",
      "instructions": "役割を選んでゾンビを動かし撃つ。\nそれぞれのラウンドには達成す必要のあるミッションがある。\nお金とダイヤモンドを獲得して、あなたの役割や武器をアップデートできる。\n行動せよ！より多くのレベルをクリアしよう！\n\nデスクトップ：\nWASDを使用してプレイヤーを動かす\n\nモバイル：\nスクリーンをスワイプして移動\n\n左右の射撃にそれぞれのボタンが2つある。",
      "genres": [
        "カジュアル",
        "シューター"
      ],
      "tags": [
        "3D",
        "エージェント",
        "銃",
        "レベル",
        "シューティングゲーム"
      ]
    },
    "ko": {
      "title": "시버박스 대사",
      "description": "시버파크 에이전트는 가장 도전적인 쏘아치기 게임으로, 흥미진진한 미션들이 가득하다.\n이 액션 팽팽하고 시각적으로 인상적인 게임을 즐기기 위해 준비하라.\n당신의 경기장은 두려운 죽음이 공격한다.\n그들은 시민을 먹고 싶어한다. 그들은 무고한 사람들을 상처받게 할 위험한 임무를 계획하고 있다.\n당신의 인민을 구하고 모든 죽음을 죽이는 시간이 되었다.\n최고의 암살자 기술을 사용하여 이 두려운 죽음과 싸워라.",
      "instructions": "캐릭터를 선택하여 좀비를 이동하고 쏘아라.\n각 라운드는 완료해야 하는 미션들이 있습니다.\n的金과 다이아몬드를 얻어 캐릭터와 무기를 업그레이드할 수 있습니다.\n와 이어서 더 많은 레벨을 통과해 보세요!\n\n데스크톱:\nWASD를 사용하여 플레이어를 이동하세요\n\n모바일:\n화면에서 슬라이드하여 이동하세요\n\n좌우쏘기 버튼이 두 개 있습니다. 하나는 왼쪽을 쏘고 다른 하나는 오른쪽을 쏘습니다.",
      "genres": [
        "캐주얼",
        "셔터"
      ],
      "tags": [
        "3D",
        "에이전트",
        "총",
        "레벨",
        "쏘아라업"
      ]
    },
    "fr": {
      "title": "Agent Cyberpunk",
      "description": "Cyberpunk Agent est le jeu de tir le plus difficile disponible, rempli de missions captivantes.\nPréparez-vous à profiter de ce jeu d'action épique et accrocheur.\nVotre arène est attaquée par des zombies terrifiants.\nIls veulent manger des civils. Ils planifient des missions dangereuses pour blesser les innocents.\nIl est temps de sauver votre peuple et de tuer tous les zombies.\nUtilisez vos meilleures compétences d'assassin et combattez ces zombies effrayants.",
      "instructions": "Choisissez le rôle à déplacer et à tirer sur les zombies.\nChaque tour a ses missions que vous devez accomplir.\nVous pouvez obtenir de l'argent et des diamants pour mettre à jour votre rôle et votre équipement.\nVenez et passez plus de niveaux !\n\nBureau :\nUtilisez WASD pour déplacer votre joueur\n\nMobile :\nGlissez sur l'écran pour vous déplacer\n\nIl y a deux boutons, l'un pour tirer à droite et l'autre pour tirer à gauche.",
      "genres": [
        "Casual",
        "Tiroir"
      ],
      "tags": [
        "3D",
        "agent",
        "armes",
        "niveaux",
        "tirez-vous sur tout"
      ]
    }
  }
};
